import { AssignOffersProvider } from 'src/contexts/AssignOffersProvider';
import { Step1 } from 'src/pages/AddPartnerPage/steps/step1_PartnerType';
import { Step2 } from 'src/pages/AddPartnerPage/steps/step2_PartnerInformation';
import Step3 from 'src/pages/AddPartnerPage/steps/step3_PaymentInformation';
import { Step4 } from 'src/pages/AddPartnerPage/steps/step4_PricingInformation';
import { Step5 } from 'src/pages/AddPartnerPage/steps/step5_ContractInformation';
import { Summary } from 'src/pages/AddPartnerPage/steps/step6_Summary';

export const ADD_PARTNER_STEPS = [
    {
        label: 'Partner Type',
        completed: false,
        form: <Step1 key={'step1'} />,
    },
    {
        label: 'Partner Information',
        completed: false,
        form: <Step2 key={'step2'} />,
    },
    {
        label: 'Payment Information',
        completed: false,
        form: <Step3 key={'step3'} />,
    },
    {
        label: 'Pricing Information',
        completed: false,
        form: (
            <AssignOffersProvider>
                <Step4 key={'step4'} />
            </AssignOffersProvider>
        ),
    },
    {
        label: 'Contract Information',
        completed: false,
        form: <Step5 key={'step5'} />,
    },
    {
        label: 'Summary',
        completed: false,
        form: <Summary key={'summary'} />,
    },
];
